import { IBaseEntity, IBaseQuery } from './common.type';

export interface IAccount extends IBaseEntity {
  username: string;
  email: string;
  phone?: string;
  fullname: string;
  avatar?: string;
  type: EAccountType;
  status: EAccountStatus;
}

export enum EAccountType {
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  USER = 'USER',
  SOURCE_INFORMATION = 'SOURCE_INFORMATION',
  PARTNER = 'PARTNER',
}

export enum EAccountStatus {
  UNACTIVE = 'UNACTIVE',
  ACTIVE = 'ACTIVE',
  SUSPEND = 'SUSPEND',
}

export interface IAccountQuery extends IBaseQuery {}

export interface IAccountBody {
  username?: string;
  email?: string;
  phone?: string;
  fullname?: string;
  password?: string;
  status?: EAccountStatus;
  type?: EAccountType;
}

export interface IChangePasswordBody {
  oldPassword: string;
  newPassword: string;
}
export interface IUpdateProfileBody {
  email?: string;
  phone?: string;
  fullname?: string;
}
